export interface ILinkInformation {
  applePayCurrencyCode: string;
  currency: string;
  amount: string;
  formActionURL: string;
  formContent: FormContent[];
}

export interface FormContent {
  name: string;
  value: string;
}

export interface IApplePayRequest {
  redirectionUrl: string;
}

/** Payload sent to `/org/sgs/apple-pay/start-session` to obtain an Apple Pay merchant session. */
export interface ApplePayStartSessionRequest {
  url: string;
  paymentReference: string;
}

/** Response from `/org/sgs/apple-pay/start-session` — an opaque, JSON-encoded merchant session. */
export interface ApplePayStartSessionResponse {
  session: string;
}

/** Payload sent to `/org/sgs/apple-pay/purchase` once the user authorizes the Apple Pay payment sheet. */
export interface ApplePayPurchaseRequest {
  apple_data: string;
  apple_signature: string;
  apple_header: {
    apple_transactionId: string;
    apple_ephemeralPublicKey: string;
    apple_publicKeyHash: string;
  };
  apple_paymentMethod: {
    apple_displayName: string;
    apple_network: string;
    apple_type: string;
  };
  payment_id: string;
}

export enum PaymentGatewayTypes {
  Payfort = 1,
  ApplePay = 2,
  Cashin = 3,
}

export interface AllowedCard {
  key: string;
  value: string;
}

export interface PaymentGateway {
  paymentGatewayType: PaymentGatewayTypes;
  allowedCards: null | AllowedCard[];
}

export interface IPaymentInfo {
  id: string;
  currency: string;
  applePayCurrencyCode: string;
  amount: number;
  gateways: PaymentGateway[];
  baseAmount: number;
  vatAmount: number;
  vatPercentage: number;
  discountAmount: number;
  slotReservationExpiresAtTimestamp?: number | null;
}
